import React, { Component } from "react";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { Provider, connect } from "react-redux";
import reducer from "../../reducers/top/services";
import saga from "../../sagas/top/services";
import actionCreators from "../../actions/top/services";
import Loader from "../../components/loader";
import Service from "../../components/top/service";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class Services extends Component {
  UNSAFE_componentWillMount() {
    store.dispatch(actionCreators.timeline.services.set());
  }
  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

const TmpRoot = ({ state }) => {
  if (state.loading) {
    return <Loader isActive={state.loading} />;
  }
  if (state.services.length == 0) return <div />;
  const services = state.services.map(function(service) {
    return <Service service={service} key={service.id} />;
  });

  // let serviceNames = state.services.map(function (service, i) {
  //   return `${i !== 0 ? '、' : ''}${service.genre}`;
  // });
  // serviceNames = serviceNames.slice(0, -2);
  return (
    <div>
      <article className="timeline-box mb10">
        <h2 className="left">
          <i className="fas fa-star icon_blue" aria-hidden="true" />&nbsp;つなげーとの姉妹サイトの新サービス
        </h2>
        <p className="small">
          さまざまなのジャンルに特化したサークルが探せるつなげーとの新サービスです。
        </p>
        <div className="touch-wrap">
          <div className="touch">{services}</div>
        </div>
      </article>
    </div>
  );
};

const mapStateToProps = (state) => ({
  state,
});

const Root = connect(mapStateToProps)(TmpRoot);
